export default "__VITE_ASSET__sIQDXEMx__"